export default __webpack_public_path__ + "static/1-0331912006fd68fe345f1c019f03081c.png";